import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'


const Wrapper = styled.div`
    margin: 3rem 1rem 1rem 1rem;
    padding: 1rem ${props => props.theme.spacer.horizontal};
    color: ${props => props.theme.colors.grey};
    margin: 0 auto;
    padding: 0 2rem 3rem;
    max-width: 55rem;
    a {
        text-decoration: none;
        color: ${props => props.theme.brand.primary};
    }
    p {font-family: "Roboto",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}
    h4 {
        font-family: "Roboto",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        font-size: 1.15rem;
        color: ${props => props.theme.colors.black};
        font-weight: normal;
        text-decoration: underline;
        margin: 0;
    }
    .cta {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            -webkit-box-orient: vertical;
            -webkit-box-direction: reverse;
                -ms-flex-direction: column-reverse;
                    flex-direction: column-reverse;
        }
    }
    .cta__desc {
        color: ${props => props.theme.colors.black};
        font-family: 'Roboto Slab', Georgia, serif;
        font-size: 1.5rem;
        line-height: 120%;
        font-weight: 300;
        margin: 0;
        padding: 0;
        text-align: left;
    }
    .cta__button {
        color: ${props => props.theme.colors.white};
        background: ${props => props.theme.colors.black};
        border-color: #111;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        padding: 20px 25px 18px 25px;
        cursor: pointer;
        display: inline-block;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        -ms-border-radius: 4px;
        -o-border-radius: 4px;
        border-radius: 4px;
        width: 10rem;
        margin-right: 3rem;
        transition: all .6s;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            width: 100%;
            margin-top: 1rem;
        }
    }
    .cta__button :hover {
        color: ${props => props.theme.brand.primary};
    }
`

const Cta = () => (
    <Wrapper data-testid="cta">
        <div className="cta">
            <div className="cta__wrap">
                <Link to="/works" data-testid="home-title-link">
                    <div className="cta__button">See More Projects</div>
                </Link>
            </div>
            <p class="cta__desc">Featured Projects. Please check works section to see more of the projects I designed and developed.</p>
        </div>
     </Wrapper>
)

export default Cta
